import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { FiltersService } from '../../../../services/base/filters.service';
import { takeUntil } from 'rxjs/operators';
import { AuthenticationService } from '../../../../services/base/authentication.service';
import { User } from '../../../../interfaces/routering/user';
import { Filters } from '../../../../interfaces/base/filters';
import * as moment from 'moment';
import { Department } from '../../../../interfaces/routering/department';

@Component({
  selector: 'fury-reassign-task-dialog',
  templateUrl: './reassign-dialog.component.html',
  styleUrls: ['./reassign-dialog.component.scss'],
})

export class ReassignDialogComponent implements OnInit, OnDestroy {

  @Output() submitData: EventEmitter<any> = new EventEmitter<any>();

  public filters: Filters = {
    users: {
      preload: true,
      isLoading: false,
      data: <User[]>[]
    }
  };

  public filterUsersCtrl: FormControl<string> = new FormControl<string>('');
  public filteredUsers: ReplaySubject<User[]> = new ReplaySubject<User[]>(1);

  public isLoading: boolean = false;

  public form = this.fb.group({
    user_id: new FormControl(<number>null, {validators: [Validators.required]}),
    note: new FormControl(<string>'', {validators: [Validators.required]}),
  });

  private destroy$: Subject<null> = new Subject<null>();

  constructor(private fb: FormBuilder,
              private filtersService: FiltersService,
              public authenticationService: AuthenticationService,
  ) {
  }

  ngOnInit(): void {
    this.filtersService.filters = this.filters;
    Object.keys(this.filters).map((key: string): void => {
      if (this.filters[key].preload) {
        this.filters[key].isLoading = true;

        this.filtersService[key]().pipe(takeUntil(this.destroy$)).subscribe((data: any): void => {
          this.filters[key].data = data;
          this.filters[key].isLoading = false;

          if (key === 'users') {
            this.filteredUsers.next(data);
          }
        });
      }
    });

    this.filterUsersCtrl.valueChanges.pipe(
      takeUntil(this.destroy$)
    ).subscribe((value: string): void => {
      const val: string = value.toLowerCase();
      this.filteredUsers.next(
        value
          ? this.filters.users.data.filter((o: User): boolean => o.name.toLowerCase().indexOf(val) > -1)
          : this.filters.users.data
      );
    });
  }

  submit(formData: any): void {
    this.submitData.emit(formData);
  }

  clearValue(field: string): void {
    this.form.get(field).setValue(null);
  }

  formatDate(date: string): string {
    return moment(date).format('DD-MM-YY');
  }

  getDepartments(departments: Department[]): string {
    return departments.map((d: Department): string => d.name).join(', ');
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();

    this.isLoading = false;
  }
}
